import { Button } from "@tellescope/ui";
import { useTranslation } from "react-i18next";

export interface SectionFooterProps {
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
}

export const SectionFooter = ({ onSave, onCancel, isSaving }: SectionFooterProps) => {
  const { t } = useTranslation("vitals");
  return (
    <div className="flex items-center justify-end gap-2 pt-2">
      <Button variant="outline" size="sm" onClick={onCancel} disabled={isSaving}>
        {t("Cancel")}
      </Button>
      <Button size="sm" onClick={onSave} disabled={isSaving}>
        {t("Save")}
      </Button>
    </div>
  );
};
